import { Toolbar, TableRow, TableCell } from "@mui/material";

type props = {
    title: string    
}

export const SectionHeader = ({title}: props) => {
    return (
        <Toolbar component={"thead"}
            sx={{
                pl: { sm: 2 },
                pr: { xs: 1, sm: 1 },
            }}
        >
            <TableRow>
                <TableCell align="left" sx={{  border: 0  }}>
                    {title}
                </TableCell>
                
            </TableRow>
        </Toolbar>
    );
}